import apiConfig from "constants/apiConfig";
import axiosClient from "utils/axiosClient";

export const fetchCollaborations = async (payload: any) => {
    const response = await axiosClient.get(apiConfig.FETCH_COLLABORATIONS.url, {params: payload});
    return response.data;
}

export const fetchCollaboration = async (campaignId: string, collaborationId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_COLLABORATION.url.replace('<campaignId>', campaignId).replace('<collaborationId>', collaborationId));
    return response.data;
}